import { ApiConstant } from "@/const";
import { ResponseDataList, ResponseSailorType } from "@/types/service";
import { DatalakeApi } from "./config/api.config";

const formatResponseData = (response?: ResponseDataList<ResponseSailorType>) => {
  return {
    ...response,
    data: response?.data?.map((item: ResponseSailorType) => {
      return {
        ...item,
        createdAt: (item?.created && new Date(item?.created)) || undefined,
      };
    }),
  };
};

export const getPersonList = async (payload: any) => {
  const response = await DatalakeApi.toCamel().get<any>(ApiConstant.GET_PERSON_LIST, payload);
  if (response.ok && response.data) return formatResponseData(response?.data?.data);
  throw response;
};
